export default __webpack_public_path__ + "static/media/background-min.f385ec91.jpg";